import React, { useState } from 'react';
import '../../entrydoor.css';

const Jambs = ({ value, onChange, label = 'Jambs:' }) => {
    const [selectedJambs, setSelectedJambs] = useState(value || "");

    const handleJambsChange = (e) => {
        setSelectedJambs(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="Jambs">{label}</label>
            <select
                id="Jambs"
                value={selectedJambs}
                onChange={handleJambsChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value='4 5/8" x 1 1/4"'>{selectedJambs === '4 5/8" x 1 1/4"' ? '4 5/8" x 1 1/4" ✔' : '4 5/8" x 1 1/4"'}</option>
                <option value='5 1/2" x 1 1/4"'>{selectedJambs === '5 1/2" x 1 1/4"' ? '5 1/2" x 1 1/4" ✔' : '5 1/2" x 1 1/4"'}</option>
                <option value='6 5/8" x 1 1/4"'>{selectedJambs === '6 5/8" x 1 1/4"' ? '6 5/8" x 1 1/4" ✔' : '6 5/8" x 1 1/4"'}</option>
                <option value='8 1/4" x 1 1/4"'>{selectedJambs === '8 1/4" x 1 1/4"' ? '8 1/4" x 1 1/4" ✔' : '8 1/4" x 1 1/4"'}</option>
            </select>
        </div>
    );
};

export default Jambs;
